import { AxiosInstance } from "axios";
import { IResponseBody } from "../../Schemas/EndPoint";
import { GatewaySchema } from "../../Schemas/Gateway";
import {
  IFilterSchema,
  IListQueryStringSchema,
  ISortSchema,
} from "../../Schemas/ListQueryString";

interface Filter extends IFilterSchema {
  column: GateWayListColumnFilterable;
}

interface Sort extends ISortSchema {
  column: GateWayListColumnSortable;
}

export enum GateWayListColumnFilterable {
  CAPTION = "caption",
  DEPARTMENT = "department",
  TICKET_NUMBER = "ticket_number",
  STATUS = "status",
  UPDATED_AT = "updated_at",
}
export enum GateWayListColumnSortable {
  CAPTION = "caption",
  DEPARTMENT = "department",
  TICKET_NUMBER = "ticket_number",
  STATUS = "status",
  UPDATED_AT = "updated_at",
  CREATED_AT = "created_at",
}
export interface GatewayListQueryString extends IListQueryStringSchema {
  filters?: Filter[];
  sorts?: Sort[];
}

export interface GatewayListResponseBody extends IResponseBody {
  data: {
    total: number;
    payment_gateways: GatewaySchema[];
  };
}

export class GatewayListRequest {
  private protectedAxiosInstance: AxiosInstance;
  private path = "/admin/payment-gateways";

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  async send(
    queryStrings?: GatewayListQueryString
  ): Promise<GatewayListResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.get(this.path, {
        params: queryStrings,
      });
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
